export default {
    data() {
        return {
			mediaTypeColor:[],//图例顔色
			mediaTypeName:[],//图例名称
			mediaTypeOrder:[],//图例顺序
			mediaTypeIDs:[],//显示的图例key
			canvasHeight:'200',//画布高度
        }
    },
	initCanvas(originItem,category,data){
		let that =this;
		var myCanvas = document.getElementById("myCanvas");
			var ctx = myCanvas.getContext("2d");
			var fontTypeface = "微软雅黑";
			ctx.font = fontTypeface;
			
			//参数配置
			var canvasWidth = 1300; //画布宽度
			var canvasHeight = 250; //画布高度
			
			canvasWidth = $("#traceRouteDiv").width()*1;
			$("#myCanvas").prop("width",canvasWidth);
			
			//alert(document.location);
			if (document.location.href.indexOf('transDetail') == -1 && document.location.href.indexOf('transDetail') == -1)
			{
				//直接引用的本include文件
				canvasHeight = $("#traceRouteDiv").height();
				//canvasHeight = 700;
			}
			
			$("#myCanvas").prop("height",canvasHeight);
			$("#route_map").css("height",canvasHeight+5);
			
			var zoom = 1;
			var canvasBackgroundColor = "rgba(0,0,0,0)";

			var marginLeft = 160/zoom;//整个图距离左侧距离
			var axisColor = "#fff"; //坐标轴颜色
			var axisTickColor = "#aaa"; //axisLabel坐标轴标签文字颜色
			
			var originItemWidth = 140;//原创文章节点宽度
			var originItemHeight = 44;//原创文章节点高度
			var originItemColor = "#1b6a81";//初始节点颜色
			var itemWidth = 80;//节点宽度
			var itemHeight = 22;//节点高度
			var legendWidth = 20;//图例宽度
			var legendHeight = 14;//图例高度
			var tipsWidth = 300;//提示框宽度
			var tipsHeight = 260;//提示框高度
			var tipsColor = "#fff";//提示框背景色
			var currentTips = {//记录当前正在显示的tips，防止重复渲染
					x:-1,
					y:-1,
					tipsX:0,
					tipsY:0
			}
			var itemCorner = 10;//节点圆角半径
			var itemFontSize = 12;//节点标签字体大小
			var itemFontCollor = "#eee";//节点标签字体颜色
			var itemFontCollor1 = "#111";//节点标签字体颜色
			var arrowScale = 0.1;//路径结尾箭头缩放大小
			var itemColor = "rgba(153, 50, 204, 1)"; //节点颜色
			//记录当前状态，是否有高亮元素， normal为没有
			//highlight: 点击节点后高亮节点以及相关点和路径
			//highlight_mediatype: 点击图例后，高亮显示图例类别下的节点
			var status = "normal";
			var clickedItemXY = {x:-1,y:-1};//记录当前点击的节点下标
			var heightLightItemMap = null;//记录需要高亮的相关节点
			var dataXYmap = new Object(); //记录每个节点的key: x_y ,value:{rectX : rectX , rectY : rectY , rectWidth : rectWidth , rectHeight : rectHeight}
			
			var legendXYmap = new Object();//图例xy坐标 key:mediaType, value:{x:x , y:y}
			var currentLegendKey = -1;//当前高亮的媒体类型key值，默认没有高亮 ：-1
			
			
			//双击节点是否打开资讯链接
			var isOpenItem = true;
			
			
			//显示信息
			function showMessages(result)
			{
				var tmpData = null;
				var source = null;
				var postTime = null;
				if (result.x==-2 && result.y==-2)
				{
					tmpData = originItem;
					source = "-"
					postTime = tmpData[9];
				}
				else
				{
					tmpData = data[result.x][result.y];
					source = tmpData[9];
					postTime = tmpData[10];
				}
				
				var msg = "来源：" + source + "； 发布时间：" + postTime;
				
				$("#tips").html(msg);
			}
			
			
		var ticksCount = (category.length-1);
		var axisWidth = canvasWidth - 120/zoom - marginLeft;
		var tickWidth = axisWidth/(ticksCount+1); //坐标轴单位宽度
		//如果单位宽度过小，则 根据节点宽度来重新计算canvas宽度
		if (tickWidth < itemWidth)
		{
			tickWidth = itemWidth
			axisWidth = (ticksCount+1) * tickWidth;
			canvasWidth = axisWidth + 120/zoom + marginLeft;
			$("#myCanvas").prop("width",canvasWidth);
		}

		//时间点媒体数最大值，每个媒体上下间距
		var maxDataTiem = 3;

		for (var i = 0 ; i < data.length; i++)
		{
			if (data[i].length > maxDataTiem)
				maxDataTiem = data[i].length;
		}
		//console.log("maxDataTiem:" + maxDataTiem);
		var dataItemHeight = (canvasHeight-100/zoom)/maxDataTiem;
		if (dataItemHeight > 60/zoom)
			dataItemHeight = 60/zoom;

		//根据data计算出当前数据中包含的媒体类型
		
		//初始化
		initMyCanvas();

		//画背景颜色
		function drawBackground(){
			ctx.beginPath();
			ctx.fillStyle=canvasBackgroundColor;
			ctx.moveTo(0,0);
			ctx.lineTo(canvasWidth,0);
			ctx.lineTo(canvasWidth,canvasHeight);
			ctx.lineTo(0,canvasHeight);
			ctx.lineTo(0,0);
			ctx.closePath();
			ctx.fill();
		}

		//画图例  区分媒体类型
		function drawLegend(){
			var fontSize = itemFontSize/zoom;
			var previousWidth = 10/zoom;
			var tmpName;
			var space = 10/zoom;
			ctx.font= "bold " + fontSize + "px " + fontTypeface;
			
			for (var i=0; i<that.mediaTypeOrder.length; i++)
			{
				var key = that.mediaTypeOrder[i];
				
				if (!hasMediaType(key))
					continue;
				
				tmpName = that.mediaTypeName[key];
				ctx.beginPath();
				ctx.shadowBlur = 0; // 模糊尺寸
				ctx.fillStyle = that.mediaTypeColor[key];
				ctx.strokeStyle = that.mediaTypeColor[key];
				ctx.rect(previousWidth,10/zoom,legendWidth,legendHeight);
				ctx.closePath();
				ctx.stroke();
				ctx.fill();
				ctx.fillStyle = itemFontCollor;
				ctx.fillText(tmpName,previousWidth + legendWidth + space/2,space+(legendHeight-fontSize)/2+fontSize*0.8);
				//保存当前图例的xy坐标
				legendXYmap[key] = {x:previousWidth , y:10/zoom};
				
				previousWidth += legendWidth + ctx.measureText(tmpName).width + space;
			}
			
		}
		//高亮选中的媒体图例
		function drawLegend_heighlight(){
			var fontSize = itemFontSize/zoom;
			var space = 10/zoom;
			ctx.font= "bold " + fontSize + "px " + fontTypeface;
			var x = legendXYmap[currentLegendKey].x;
			var y = legendXYmap[currentLegendKey].y;
			var tmpName = that.mediaTypeName[currentLegendKey];
			ctx.beginPath();
			ctx.shadowBlur = 8; // 模糊尺寸
			ctx.shadowColor = 'rgba(256, 256, 256, 0.7)'; // 颜色
			ctx.fillStyle = that.mediaTypeColor[currentLegendKey];
			ctx.strokeStyle = that.mediaTypeColor[currentLegendKey];
			ctx.rect(x,y,legendWidth,legendHeight);
			ctx.closePath();
			ctx.stroke();
			ctx.fill();
			
			ctx.fillStyle = itemFontCollor;
			ctx.fillText(tmpName,x + legendWidth + space/2,space+(legendHeight-fontSize)/2+fontSize*0.8);
		}
		//是否显示该媒体类型图例
		function hasMediaType(id){
			for (var i = 0;i<that.mediaTypeIDs.length;i++)
			{
				if (that.mediaTypeIDs[i]==id)
					return true;
			}
			return false;
		}

		//画坐标轴
		function drawAxis(ctx){
			ctx.shadowBlur = 0; // 模糊尺寸
			ctx.strokeStyle = axisColor;
			ctx.lineWidth = 1/zoom;
			for (var i = 0 ; i < ticksCount ; i++)
			{
				var text = category[i];
				var nextText = category[i+1];
				
				if (text!="..." && nextText!="...")
				{
					ctx.beginPath();
					ctx.moveTo(marginLeft + 50/zoom + i*tickWidth,canvasHeight-50/zoom);
					ctx.lineTo(marginLeft + 50/zoom + (i+1)*tickWidth,canvasHeight-50/zoom);
					ctx.stroke();
				}
				
				if (text != "..." && nextText=="...")
				{
					ctx.beginPath();
					drawDashLine(
							marginLeft + 50/zoom + (i+1)*tickWidth - tickWidth*4/5,canvasHeight-50/zoom,
							marginLeft + 50/zoom + (i+1)*tickWidth + tickWidth*4/5,canvasHeight-50/zoom,
							2.5/zoom
					);
					ctx.moveTo(marginLeft + 50/zoom + i*tickWidth,canvasHeight-50/zoom);
					ctx.lineTo(marginLeft + 50/zoom + (i+1)*tickWidth - tickWidth*4/5,canvasHeight-50/zoom);
					ctx.stroke();
				}
				
				if (text == "..." && nextText!="...")
				{
					ctx.beginPath();
					ctx.moveTo(marginLeft + 50/zoom + i*tickWidth + tickWidth*4/5,canvasHeight-50/zoom);
					ctx.lineTo(marginLeft + 50/zoom + (i+1)*tickWidth,canvasHeight-50/zoom);
					ctx.stroke();
				}
				
			}
		}
		//画虚线 x1,y1开始坐标， x2,y2结束坐标，dashLen虚线单位长度
		function drawDashLine(x1,y1,x2,y2,dashLen){
			//求线段段长度
			var beveling = getBeveling(x2-x1,y2-y1);
			//计算有多少线段
			var num = Math.floor(beveling/dashLen);
			for(var i = 0 ; i < num; i++)
			{
				if (i%2==0)
				{
					//console.log("x:" + (x1+(x2-x1)/num*i) + ";y:" + (y1+(y2-y1)/num*i));
					ctx.moveTo(x1+(x2-x1)/num*i,y1+(y2-y1)/num*i);
				}
				else
				{
					//console.log("x:" + (x1+(x2-x1)/num*i) + ";y:" + (y1+(y2-y1)/num*i));
					ctx.lineTo(x1+(x2-x1)/num*i,y1+(y2-y1)/num*i);
				}
			}
			ctx.stroke();
		}

		//求斜边长度  
		function getBeveling(x,y)  
		{  
			return Math.sqrt(Math.pow(x,2)+Math.pow(y,2));  
		}  

		//画坐标刻度线
		function drawAxisTick(ctx){
			ctx.shadowBlur = 0; // 模糊尺寸
			for (var i = 0 ; i <= ticksCount ; i++)
			{
				var text = category[i];
				if (text == "...")
					continue;
				
				ctx.lineWidth = 1/zoom;
				ctx.beginPath();
				ctx.moveTo(marginLeft + 50/zoom + i*tickWidth,canvasHeight-50/zoom);
				ctx.lineTo(marginLeft + 50/zoom + i*tickWidth,canvasHeight-40/zoom);
				ctx.closePath();
				ctx.stroke();
				//axisLabel坐标轴标签文字部分
				ctx.fillStyle=axisTickColor;
				var fontSize = 14/zoom;
				ctx.font= fontSize*0.8 + "px " + fontTypeface;
				
				if (text != "...")
					text = text.substring(5,13);
				var textW = ctx.measureText(text).width;
				ctx.fillText(text,marginLeft + 50/zoom + i*tickWidth-textW/2,canvasHeight-40/zoom + fontSize);
					
			}
			
		}
		//保存初始节点xymap
		function saveOriginItemXY(){
			var x = marginLeft/2 - originItemWidth/(zoom*2)+20;
			var y = (canvasHeight - 50/zoom - originItemHeight/zoom)/2;
			dataXYmap["-2_-2"] = {rectX : x , rectY : y , rectWidth : originItemWidth/zoom , rectHeight : originItemHeight/zoom};
		}
		//画初始节点
		function drawOriginItem(){
			var x = dataXYmap["-2_-2"].rectX;
			var y = dataXYmap["-2_-2"].rectY;
			var w = dataXYmap["-2_-2"].rectWidth;
			var h = dataXYmap["-2_-2"].rectHeight;
			var fontSize = itemFontSize*1.2/zoom;
			ctx.font= "bold " + fontSize + "px " + fontTypeface;
			var name = originItem[0] + "[" + originItem[4] + "]";
			if (ctx.measureText(name).width > (w - 10/zoom))
				w = ctx.measureText(name).width + 50/zoom;
				
			if (-2 == clickedItemXY.x && -2==clickedItemXY.y)
			{
				w = w + 12/zoom;
				h = h + 12/zoom;
				x = x - 6/zoom;
				y = y - 6/zoom;
				fontSize = fontSize + 4/zoom;
				ctx.font= "bold " + fontSize + "px " + fontTypeface;
			}
			ctx.shadowBlur = 4; // 模糊尺寸
			if (status == "highlight")
			{
				ctx.shadowColor = 'rgba(256, 256, 256, 0.7)'; // 颜色
			}
			ctx.strokeStyle = originItemColor;
			ctx.fillStyle = originItemColor;
			drawEllipse(ctx,x + w/2,y + h/2,w/2,h/2);
			ctx.fillStyle=itemFontCollor;
			ctx.shadowBlur = 0;
			var textW = ctx.measureText(name).width;
			var textX = x + w/2 - textW/2;
			ctx.fillText(name,textX,y+(h-fontSize)/2+fontSize*0.8);
			
			ctx.font= "bold " + fontSize*0.8 + "px " + fontTypeface;
			var timeW = ctx.measureText(originItem[9]).width;
			var timeX = x + w/2 - timeW/2;
			ctx.fillText(originItem[9],timeX,y+(h-fontSize)/2+fontSize*0.8  + h);
		}

		//保存每个节点的xy下标以及，矩形的开始坐标
		//画节点
		function drawDataItems(){
			
			//保存所有节点的路径信息
			var pathArr = new Array();
			for (var i = 0 ; i <= ticksCount ; i++)
			{
				//每个时间段的一组媒体
				var dataArray = data[i];
				if (dataArray != undefined)
				{
					for (var j = 0 ; j < dataArray.length ; j++)
					{
						//高亮媒体类型
						if (status == "highlight_mediatype" && dataArray[j][7] == currentLegendKey)
						{
							continue;
						}
							
						var px = -1;
						var py = -1;
						if (status == "highlight" && heightLightItemMap[i+"_"+j] != null)
						{
							px = heightLightItemMap[i+"_"+j][2];
							py = heightLightItemMap[i+"_"+j][3];
						}
						
						//判断本节点是否包含在高亮节点内
						//当前节点和父节点都在高亮节点列表内，则当前节点以及路径 都不画
						if (status == "highlight" && heightLightItemMap[i+"_"+j] != null && heightLightItemMap[px+"_"+py] != null)
						{
							continue;
						}
						//当前节点在，但是父节点不在，则只画路径，不画节点
						if (status == "highlight" && heightLightItemMap[i+"_"+j] != null && heightLightItemMap[px+"_"+py] == null)
						{
							var tmpPath = [dataArray[j][2],dataArray[j][3],i,j,dataArray[j][0]];
							pathArr.push(tmpPath);
							continue;
						}
						
						//保存本节点的矩形开始坐标
						if (status == "normal")
						{
							var whxy = getDataItemWHXY(ctx, dataArray[j][0], i, j, dataArray.length);
							dataXYmap[i+"_"+j] = {rectX : parseFloat(whxy.split("_")[2]) , 
									rectY : parseFloat(whxy.split("_")[3]) , 
									rectWidth : parseFloat(whxy.split("_")[0]) , 
									rectHeight : parseFloat(whxy.split("_")[1])};
						}
						
						//记录下每个节点的parent和它自己的 [x_index,y_index]（这儿是指x:轴的index，y_index数组下标）
						//[pX,pY,x,y,name,length]因为每个节点宽度由name长度决定所以需要保留这个值
						var tmpPath = [dataArray[j][2],dataArray[j][3],i,j,dataArray[j][0]];
						pathArr.push(tmpPath);
						
					}
				}
					
			}
			//画线
			drawPathLine(pathArr,dataXYmap,false);
			
			//画节点
			var heightLight = false;
			for (var key in dataXYmap)
			{
				var x = key.split("_")[0];
				var y = key.split("_")[1];
				//初始节点不画，在别的地方画
				if (x==-2&&y==-2)
					continue;
				var tmpData = data[x][y];
				
				//高亮媒体类型节点不画
				if (status == "highlight_mediatype" && tmpData[7] == currentLegendKey)
					continue;
				//高亮节点不画
				if (status == "highlight" && heightLightItemMap[x+"_"+y] != null)
					continue;
				
				drawDataItem(ctx, tmpData[0],x,y,data[x].length, tmpData[4],heightLight);
			}
		}

		//画节点(高亮)
		function drawHeightLightDataItems(){
			var pathArr = new Array();
			for (var i = 0 ; i <= ticksCount ; i++)
			{
				//每个时间段的一组媒体
				var dataArray = data[i];
				if (dataArray != undefined)
				{
					for (var j = 0 ; j < dataArray.length ; j++)
					{
						//高亮媒体类型
						if (status == "highlight_mediatype" && dataArray[j][7] != currentLegendKey)
						{
							continue;
						}
						
						var px = -1;
						var py = -1;
						if (status == "highlight" && heightLightItemMap[i+"_"+j] != null)
						{
							px = heightLightItemMap[i+"_"+j][2];
							py = heightLightItemMap[i+"_"+j][3];
						}
						//判断本节点是否包含在高亮节点内
						//当前节点和父节点都在不在高亮节点列表内，则当前节点以及路径 都不画
						if (status == "highlight" && heightLightItemMap[i+"_"+j] == null)
						{
							continue;
						}
						var heightLight = true;
						//当前节点在，但是父节点不在，则只画节点，不画路径
						if (status == "highlight" && heightLightItemMap[i+"_"+j] != null && heightLightItemMap[px+"_"+py] == null)
						{
							continue;
						}
						
						//记录下每个节点的parent和它自己的 [x_index,y_index]（这儿是指x:轴的index，y_index数组下标）
						//[pX,pY,x,y,name,length]因为每个节点宽度由name长度决定所以需要保留这个值
						var tmpPath = [dataArray[j][2],dataArray[j][3],i,j,dataArray[j][0]];
						pathArr.push(tmpPath);
						
					}
				}
					
			}
			
			drawPathLine(pathArr,dataXYmap,true);
			var heightLight = true;
			for (var key in dataXYmap)
			{
				var x = key.split("_")[0];
				var y = key.split("_")[1];
				//初始节点不画，在别的地方画
				if (x==-2&&y==-2)
					continue;
				var tmpData = data[x][y];
				
				//不高亮媒体类型节点不画
				if (status == "highlight_mediatype" && tmpData[7] != currentLegendKey)
					continue;
				//不高亮节点不画
				if (status == "highlight" && heightLightItemMap[x+"_"+y] == null)
					continue;
				
				drawDataItem(ctx, tmpData[0],x,y,data[x].length, tmpData[4],heightLight);
			}
		}

		//画单个节点
		//length 当前时间段的媒体数量， 用于 均匀分布媒体位置
		//由于坐标位置相对随机，为了后续画出路径，本方法也返回当前节点的矩形开始坐标
		function drawDataItem(ctx, name, x, y, length, childCount, heightLight){
			//节点的宽度与文字大小有关，所以此处的fontSize应该与drawPathLine中统一
			var fontSize = itemFontSize/zoom;
			if (x == clickedItemXY.x && y==clickedItemXY.y)
				fontSize = fontSize + 5/zoom;
			ctx.font= "lighter " + fontSize + "px " + fontTypeface;
			
			var whxy = getDataItemWHXY(ctx, name, x, y, length);
			
			var rectWidth = parseFloat(whxy.split("_")[0]);
			var rectHeight = parseFloat(whxy.split("_")[1]);
			
			//矩形的开始坐标（x）
			var rectX = parseFloat(whxy.split("_")[2]);
			var rectY = parseFloat(whxy.split("_")[3]);
			
			ctx.shadowBlur = 4; // 模糊尺寸
			if (heightLight)
				ctx.shadowColor = 'rgba(256, 256, 256, 0.7)'; // 颜色
			else
				ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'; // 颜色
			var mediaType = data[x][y][7];
			//根据媒体类型设置边框颜色
			ctx.strokeStyle = that.mediaTypeColor[mediaType];
			var rectWidth_copy = rectWidth;
			var rectHeight_copy = rectHeight;
			if (x == clickedItemXY.x && y==clickedItemXY.y)
			{
				if (childCount > 0)
					name = name + "[" + childCount + "]";
				if (ctx.measureText(name).width > rectWidth)
				{
					rectWidth_copy = ctx.measureText(name).width + 20/zoom;
					rectHeight_copy = rectHeight + 20/zoom;
				}
				else
				{
					rectWidth_copy = rectWidth + 20/zoom;
					rectHeight_copy = rectHeight + 20/zoom;
				}
				
			}
				
			if (childCount > 0)
			{
				//椭圆
				ctx.fillStyle = that.mediaTypeColor[mediaType];
				//drawCornerRectFill(ctx,rectX - (rectWidth_copy-rectWidth)/2,rectY - (rectHeight_copy-rectHeight)/2,rectWidth_copy,rectHeight_copy,itemCorner);
				drawEllipse(ctx,rectX+rectWidth_copy/2 - (rectWidth_copy-rectWidth)/2, rectY+rectHeight/2, rectWidth_copy/2, rectHeight_copy/2);
				//设置字体颜色
				ctx.fillStyle=itemFontCollor1;
			}
			else
			{
				//圆角矩形
				drawCornerRect(ctx,rectX - (rectWidth_copy-rectWidth)/2,rectY - (rectHeight_copy-rectHeight)/2,rectWidth_copy,rectHeight_copy,itemCorner);
				ctx.fillStyle=itemFontCollor;
			}
			//节点标签名称
			ctx.shadowBlur = 0; // 设置模糊尺寸为0,去掉标签名的阴影
			
			name = name.trim();
			
			if (x != clickedItemXY.x || y!=clickedItemXY.y)
				name = reSubstring(name, rectWidth);
			var textW = ctx.measureText(name).width;
			var textX = marginLeft + 50/zoom + x*tickWidth - textW/2 + tickWidth/2;
			ctx.fillText(name,textX,rectY+(rectHeight-fontSize)/2+fontSize*0.8);
			
			return {rectX : rectX , rectY : rectY , rectWidth : rectWidth , rectHeight : rectHeight}
		}

		//画椭圆
		function drawEllipse(ctx,x,y,w,h){
			ctx.lineWidth = 1/zoom;
			var k = .5522848;
			var ox = w*k;
			var oy = h*k;
			ctx.beginPath();
			ctx.moveTo(x-w,y);
			ctx.bezierCurveTo(x-w,y-oy,x-ox,y-h,x,y-h);
			ctx.bezierCurveTo(x+ox,y-h,x+w,y-oy,x+w,y);
			ctx.bezierCurveTo(x+w,y+oy,x+ox,y+h,x,y+h);
			ctx.bezierCurveTo(x-ox,y+h,x-w,y+oy,x-w,y);
			ctx.closePath();
			ctx.stroke();
			ctx.fill();
		}

		//画圆角矩形
		function drawCornerRect(ctx,x,y,w,h,r){
			ctx.lineWidth = 1/zoom;
			ctx.beginPath();
			ctx.moveTo(x+r,y);
			ctx.arcTo(x+w,y,x+w,y+r,r);
			ctx.arcTo(x+w,y+h,x+w-r,y+h,r);
			ctx.arcTo(x,y+h,x,y+h-r,r);
			ctx.arcTo(x,y,x+r,y,r);
			ctx.closePath();
			ctx.stroke();
		}

		//画圆角矩形(实心)
		function drawCornerRectFill(ctx,x,y,w,h,r){
			ctx.lineWidth = 2/zoom;
			ctx.beginPath();
			ctx.moveTo(x+r,y);
			ctx.arcTo(x+w,y,x+w,y+r,r);
			ctx.arcTo(x+w,y+h,x+w-r,y+h,r);
			ctx.arcTo(x,y+h,x,y+h-r,r);
			ctx.arcTo(x,y,x+r,y,r);
			ctx.closePath();
			ctx.stroke();
			ctx.fill();
		}

		//根据字符串以及字符串所在位置的宽度截取字符串使其自适应
		function reSubstring(text, width){
			var length = text.length;
			var textW = ctx.measureText(text).width;
			for (var i=0;i<length;i++)
			{
				//至少四个字
				if (text.length == 4)
					break;
				if (textW <= 0.8*width)
					break;
				text = text.substring(0,text.length-1);
				textW = ctx.measureText(text).width;
			}
			return text;
		}
		//根据当前节点的信息获取节点的矩形高度、宽度、起始x、y下标、length:当前组(group)的长度
		//这个方法单独拿出来是为了节点之间连线时获取坐标用的
		//因为节点的大小不固定，所以坐标要计算得出
		function getDataItemWHXY(ctx, name, x, y, length){
			var rectWidth = null;
			var rectHeight = null;
			var rectX = null;
			var rectY = null;
			if (dataXYmap[x+"_"+y]!=null)
			{
				rectX = dataXYmap[x+"_"+y].rectX;
				rectY = dataXYmap[x+"_"+y].rectY;
				rectWidth = dataXYmap[x+"_"+y].rectWidth;
				rectHeight = dataXYmap[x+"_"+y].rectHeight;
				return rectWidth+"_"+rectHeight+"_"+rectX+"_"+rectY;
			}
			
			//测量大小之前要把字体设置为默认大小
			var fontSize = itemFontSize/zoom;
			if (x == clickedItemXY.x && y==clickedItemXY.y)
				fontSize = fontSize + 10/zoom;
			ctx.font= "lighter " + fontSize + "px " + fontTypeface;
			
			rectWidth = itemWidth/zoom;
			rectHeight = itemHeight/zoom;
			
			//节点最大宽度设置为刻度宽度的0.6倍,这里计算出的宽度是矩形部分的宽度， 不包含两遍半圆部分，所以倍数要更小才能保证不超出范围
			if (rectWidth > 0.8*tickWidth)
				rectWidth = 0.8*tickWidth;
			
			rectX = marginLeft + 50/zoom + x*tickWidth - rectWidth/2 + tickWidth/2;
			
			var dataitemSpace = (canvasHeight-50/zoom)/(length + 1);
			
			var random = getRandom()/3;//-1/3~1/3之间的数
			
			rectY = canvasHeight-50/zoom-dataitemSpace*(y+1+random);
			
			return rectWidth+"_"+rectHeight+"_"+rectX+"_"+rectY;
		}

		//画路径
		//pathArr   [pX,pY,x,y,name,length]
		//dataXYmap [x+"_"+y] = {rectX : rectX , rectY : rectY }
		function drawPathLine(pathArr,dataXYmap,heightLight){
			//节点的宽度与文字大小有关，而路径的位置与节点宽度也有关系，所以此处的fontSize应该与drawDataItem中统一
			var fontSize = itemFontSize/zoom;
			ctx.shadowBlur = 0; // 模糊尺寸
			if (heightLight)
			{	
				ctx.strokeStyle = "#999";
				ctx.fillStyle = "#999";
			}
			else
			{	
				ctx.strokeStyle = "#666";
				ctx.fillStyle = "#666";
			}
			ctx.lineWidth = 1/zoom;
			for (var i=0 ; i < pathArr.length ; i ++)
			{
				//[pX,pY,x,y,name]
				var tmpPath = pathArr[i];
				//没有父节点
				if (tmpPath[0]==-1 || tmpPath[1]==-1)
					continue;
				
				var tmpPx = tmpPath[0];
				var tmpPy = tmpPath[1];
				var tmpX = tmpPath[2];
				var tmpY = tmpPath[3];
				var name = tmpPath[4];
				var pName = null;
				//父节点为原创站点
                if (tmpPath[0]==-2 || tmpPath[1]==-2){
                    pName = "";
                }else if(data[tmpPath[0]] && data[tmpPath[0]].length > 0){
                    if(data[tmpPath[0]][tmpPath[1]] && data[tmpPath[0]][tmpPath[1]].length > 0){
                        pName = data[tmpPath[0]][tmpPath[1]][0]
                    }else{
                        continue;
                    }
                }else{
                    continue;
                }
				
				if ((tmpX == clickedItemXY.x && tmpY==clickedItemXY.y) || (tmpPx == clickedItemXY.x && tmpPy==clickedItemXY.y))
					ctx.font= "bold " + (fontSize + 5/zoom) + "px " + fontTypeface;
				else
					ctx.font= "bold " + fontSize + "px " + fontTypeface;
				
				if (data[tmpX][tmpY][4] > 0)
				{
					ctx.strokeStyle = "#fff";
					ctx.fillStyle = "#fff";
				}
				else if (!heightLight)
				{
					ctx.strokeStyle = "#666";
					ctx.fillStyle = "#666";
				}
				
				var rectWidth = dataXYmap[tmpX + "_" + tmpY].rectWidth;
				var rectWidth_copy = rectWidth;
				if (tmpX == clickedItemXY.x && tmpY==clickedItemXY.y)
				{
					//如果子节点数大于零
					if ( data[tmpX][tmpY][4] > 0)
						name = name + "[" + data[tmpX][tmpY][4] + "]";
					if ( ctx.measureText(name).width > rectWidth)
						rectWidth_copy = ctx.measureText(name).width + 20/zoom;
					else
						rectWidth_copy = rectWidth + 20/zoom;
				}
				var pRectWidth_copy = rectWidth;
				
				if (tmpPx == clickedItemXY.x && tmpPy==clickedItemXY.y)
				{
					//如果子节点数大于零
					if (tmpPath[0]!=-2 && tmpPath[1]!=-2 && data[tmpPx][tmpPy][4] > 0)
						pName = pName + "[" + data[tmpPx][tmpPy][4] + "]";
					if (ctx.measureText(pName).width > rectWidth)
						pRectWidth_copy = ctx.measureText(pName).width + 20/zoom;
					else
						pRectWidth_copy = rectWidth + 20/zoom;
				}
				
				//路径结束位置坐标（子节点左边半圆顶点坐标）
				var whxy = getDataItemWHXY(ctx,name,tmpX,tmpY,0);
				var endX = parseFloat(dataXYmap[tmpX + "_" + tmpY].rectX);
				if (tmpX == clickedItemXY.x && tmpY==clickedItemXY.y)
					endX = parseFloat(dataXYmap[tmpX + "_" + tmpY].rectX - (rectWidth_copy- rectWidth)/2);
				
				var endY = parseFloat(dataXYmap[tmpX + "_" + tmpY].rectY)+parseFloat(whxy.split("_")[1])/2;
				//路径开始位置坐标（父节点右边半圆顶点坐标）
				var pWhxy = getDataItemWHXY(ctx,pName,tmpPx,tmpPy,0);
				var startX = parseFloat(dataXYmap[tmpPx + "_" + tmpPy].rectX)+parseFloat(pWhxy.split("_")[0]);
				if (tmpPx == clickedItemXY.x && tmpPy==clickedItemXY.y)
					startX = parseFloat(dataXYmap[tmpPx + "_" + tmpPy].rectX + (pRectWidth_copy - rectWidth)/2)+parseFloat(pWhxy.split("_")[0]);
						
				var startY = parseFloat(dataXYmap[tmpPx + "_" + tmpPy].rectY)+parseFloat(pWhxy.split("_")[1])/2;

				//用二次方贝兹曲线的路径，这里计算出控制点的坐标
				//if ()
				var cpX = startX;
				var cpY = endY;
				
				//如果子节点在父节点左侧， 则调整路径结束坐标为子节点右侧
				if (startX > endX + rectWidth_copy)
					endX = endX + rectWidth_copy;
				ctx.beginPath();
				ctx.moveTo(startX,startY);
				ctx.quadraticCurveTo(cpX,cpY,endX,endY);
				//ctx.lineTo(endX,endY);
				//ctx.closePath();
				ctx.stroke();
				//在线上显示出小时数
				ctx.font= "bold " + itemFontSize/zoom + "px " + fontTypeface;
				
				var cp0 = {x:startX,y:startY};
				var cp1 = {x:cpX,y:cpY};
				var cp2 = {x:endX,y:endY};
				var t = 0.5;
				//通过贝塞尔曲线函数获取坐标
				var textXY = qBerzier(cp0,cp1,cp2,t);
				
				ctx.fillText(data[tmpX][tmpY][6]+"h",textXY.x,textXY.y);
				
				//在路径结束位置画箭头
				drawArrow(cpX,cpY,endX,endY);
			}
		}

		//画路径的箭头
		//sx,sy,ex,ey开始坐标、结束坐标、是否高亮
		function drawArrow(sx,sy,ex,ey){
			ctx.lineWidth = 1/zoom;
			var k = -(ey-sy)/(ex-sx);//因为canvas元素中的坐标轴y轴是反的，所以要乘以-1
			
			var start = {x:0,y:0},end = {x:1,y:k};
			//记录结束坐标在开始坐标的 象限 数 ， 默认第一象限
			var quadrant = 1;
			
			if ( sx > ex && sy <= ey )
				quadrant = 3;
			if ( sx > ex && sy > ey )
				quadrant = 2;
				
			var scale=arrowScale;
			
			var arrow_x = ex;
			var arrow_y = ey;
			ctx.beginPath();
			ctx.moveTo(arrow_x,arrow_y);
			ctx.lineTo(arrow_x+rotateArrow(start,end,-100*scale,-50*scale,quadrant).x,arrow_y+rotateArrow(start,end,-100*scale,-50*scale,quadrant).y);
			ctx.bezierCurveTo(arrow_x+rotateArrow(start,end,-70*scale,-25*scale,quadrant).x,arrow_y+rotateArrow(start,end,-70*scale,-25*scale,quadrant).y,
							  arrow_x+rotateArrow(start,end,-70*scale,25*scale,quadrant).x,arrow_y+rotateArrow(start,end,-70*scale,25*scale,quadrant).y,
							  arrow_x+rotateArrow(start,end,-100*scale,50*scale,quadrant).x,arrow_y+rotateArrow(start,end,-100*scale,50*scale,quadrant).y);
			ctx.lineTo(arrow_x,arrow_y);
			ctx.closePath();
			ctx.fill();
		}

		//旋转箭头
		//start,end是确定弧度的起始终点坐标，x,y是需要转换的坐标
		function rotateArrow(start,end,x,y,quadrant){
			var diff_x = end.x - start.x,
				diff_y = end.y - start.y;
			//计算出弧度 
			var radian = Math.atan(diff_y/diff_x);
			
			var _x = x*Math.cos(radian) + y*Math.sin(radian),
				_y = -x*Math.sin(radian) + y*Math.cos(radian);
			
			if (quadrant == 3 || quadrant == 2)
			{
				_x = -_x;
				_y = -_y;
			}
			return {
				x:_x,
				y:_y
			}	
		}

		//随机获取一个-1到1之间的数
		function getRandom(){
			var random = Math.random();
			if (Math.random > 0.5)
				random = -random;
			return random;
		}

		//===========事件处理start=================
		$("#myCanvas").mousemove(function(e){
			var eventPosition = getEventPosition(e);
			var ex = eventPosition.x/zoom;
			var ey = eventPosition.y/zoom;
			
			//判断是否经过节点
			var result = getClickedItem(ex, ey);
			
			//判断是否经过图例
			var legendResult = getClickedLegend(ex, ey);
			
			if (result.x != -1 && result.y != -1 || legendResult >= 0)
			{
				//显示当前节点详细信息悬浮窗
				//showTips(result);
				this.style.cursor='pointer';
			}
			else
			{
				//去掉tips悬浮窗
				//hideTips();
				this.style.cursor='auto';
			}
			
		});

		var timer;
		var times = 0;

		$("#myCanvas").mousedown(function(){
			clearInterval(timer);
			times=0;
			
			timer = setInterval(function(){times += 0.1},100);
		});

		$("#myCanvas").mouseup(function(e){
			clearInterval(timer);
			
			if (times < 0.2)
			{
				myCanvasClick(e);
			}
			times=0;
		});

		function myCanvasClick(e){
			var eventPosition = getEventPosition(e);
			
			//console.log(ctx.isPointInPath(eventPosition.x/zoom,eventPosition.y/zoom));
			var ex = eventPosition.x/zoom;
			var ey = eventPosition.y/zoom;
			//console.log("ex:" + ex + ", ey:" + ey);
			//判断是否经过节点
			var result = getClickedItem(ex, ey);
			
			//判断是否经过图例
			var legendResult = getClickedLegend(ex, ey);
			
			if (result.x != -1 && result.y != -1 || legendResult >= 0)
			{
				//点击图例
				if (legendResult >= 0)
				{
					status = "highlight_mediatype";
					currentLegendKey = legendResult;
					heightLightItemMap = new Array();
				}
				else//点击节点
				{
					//如果点击的是当前已被点击的节点，则在新窗口中打开超链接
					if (clickedItemXY.x==result.x && clickedItemXY.y==result.y)
						openItem();
						
					status = "highlight";
					//根据被点击的节点，获取与其相关的节点
					clickedItemXY = result;
					heightLightItemMap = getRelatedItem(result);
					currentLegendKey = -1;
					
					//在图表下方显示出节点信息
					showMessages(result);
				}
				
				initMyCanvas();
			}
			else
			{
				status = "refresh";
				clickedItemXY = {x:-1, y:-1};
				currentLegendKey = -1;
				heightLightItemMap = new Array();
				initMyCanvas();
			}
		};

		function getEventPosition(ev){
		  var x, y;
		  if (ev.layerX || ev.layerX == 0) {
			x = ev.layerX;
			y = ev.layerY;
		  } else if (ev.offsetX || ev.offsetX == 0) { // Opera
			x = ev.offsetX;
			y = ev.offsetY;
		  }
		  return {x: x, y: y};
		}

		//获取当前点击的节点的x_y下标值
		//如果当前点击的坐标不属于任何节点，则返回-1,-1
		function getClickedItem(ex, ey){
			var x = -1;
			var y = -1;
			
			for (var o in dataXYmap)
			{
				//{rectX : rectX , rectY : rectY , rectWidth : rectWidth , rectHeight : rectHeight}
				var tmpItem = dataXYmap[o];
				//console.log(dataXYmap[o].rectX);
				//console.log(o.split("_")[1]);
				if (isInItem(ex, ey, tmpItem))
				{
					//设置x_y值
					x = o.split("_")[0];
					y = o.split("_")[1];
					break;
				}
			}
			
			return {x:x,y:y};
		}
		//判断当前事件坐标是否在图例范围内,返回图例key
		//如果不在 则返回-1
		function getClickedLegend(ex, ey){
			var result = -1;
			for (var key in legendXYmap)
			{
				var tmpLegnedXY = legendXYmap[key];
				var x = tmpLegnedXY.x;
				var y = tmpLegnedXY.y;
				
				if (ex >= x && ex <= (x + itemWidth) && ey >= 10/zoom && ey <= (10/zoom + itemHeight))
				{
					result = key;
					break;
				}
			}
			return result;
		}

		//判断坐标是否在节点范围内
		function isInItem(ex, ey, xywh){
			var x = xywh.rectX;
			var y = xywh.rectY;
			var w = xywh.rectWidth;
			var h = xywh.rectHeight;
			//console.log(Math.sin(ey - y));
			if (ex >= x && ex <= (x + w) && ey >= y && ey <= (y + h))
				return true;
			else
				return false;
		}

		//重新绘制节点以及路径
		function initMyCanvas(){
			ctx.globalAlpha = 1;
			ctx.clearRect(0,0,canvasWidth,canvasHeight);  
			drawBackground();
			drawLegend();
			drawAxis(ctx);
			drawAxisTick(ctx);
			saveOriginItemXY();
			drawDataItems();
			if (heightLightItemMap==null||heightLightItemMap["-2_-2"]==null)
				drawOriginItem();
			if (status=="highlight" || status=="highlight_mediatype")
			{
				//处于某些节点高亮状态
				//则其他地方变成灰色
				ctx.beginPath();
				ctx.globalAlpha = 0.7;
				ctx.shadowBlur = 0; // 模糊尺寸
				ctx.fillStyle = "#111";
				ctx.rect(0,0,canvasWidth,canvasHeight);
				ctx.fill();

				drawAxis(ctx);
				drawAxisTick(ctx);
				
				if (status == "highlight_mediatype")
					drawLegend_heighlight();
				ctx.globalAlpha = 1;
				drawHeightLightDataItems();
				
				if ((status=="highlight" && heightLightItemMap["-2_-2"]!=null) || status=="highlight_mediatype")
					drawOriginItem();
			}
		}
		//根据被点击的节点，获取与其相关的节点
		function getRelatedItem(result){
			var itemMap = new Object();
			var item = null;
			if (result.x == -2 && result.y == -2)
				item = originItem;
			else
				item = data[result.x][result.y];
			
			itemMap[result.x+"_"+result.y] = item;
			//如果有父节点的话，父节点也要保存起来
			if (item[2]!=-1&&item[3]!=-1&&item[2]!=-2&&item[3]!=-2)
				itemMap[item[2]+"_"+item[3]] = data[item[2]][item[3]];
			//父节点为原创节点
			if (item[2]==-2&&item[3]==-2)
				itemMap[item[2]+"_"+item[3]] = originItem;
			//其一级子节点也保存起来
			for (var i = 0 ; i < data.length ; i ++)
			{
				var dataArray = data[i];
				for (var j=0 ; j<dataArray.length;j++)
				{
					if (dataArray[j][2] == result.x && dataArray[j][3] == result.y)
						itemMap[i+"_"+j] = dataArray[j];
				}
			}
			return itemMap;
		}
		//打开当前已点击节点的网站链接
		function openItem(){
			if(isOpenItem != undefined && isOpenItem == false)
				return;
			
			if (clickedItemXY.x==-2&&clickedItemXY.y==-2)
				window.open(originItem[8]);
			else
				window.open(data[clickedItemXY.x][clickedItemXY.y][8]);
		}

		//显示悬浮框
		function showTips(indexXY){
			if (currentTips.x == indexXY.x && currentTips.y == indexXY.y)
				return;
			
			currentTips.x = indexXY.x;
			currentTips.y = indexXY.y;
			
			var tmpXYWH = dataXYmap[indexXY.x+"_"+indexXY.y];
			var x = tmpXYWH.rectX;
			var y = tmpXYWH.rectY;
			var w = tmpXYWH.rectWidth;
			var h = tmpXYWH.rectHeight;
			
			var tipsX,tipsY;
			var tipsSpace = 20/zoom;
			//默认显示在当前节点为中心的第四象限
			var quadrant = 4;
			if ((y + tipsHeight) > (canvasHeight - 50/zoom))
			{
				quadrant = 1;
				if ((x + w + tipsWidth + tipsSpace) > (canvasWidth - 50/zoom))
					quadrant = 2;
			}
			else
			{
				if ((x + w + tipsWidth + tipsSpace) > (canvasWidth - 50/zoom))
					quadrant = 2;
				if ((x + h - tipsHeight))
					quadrang = 3;
			}
			
			if (quadrant == 1)
			{
				tipsX = x + w + tipsSpace;
				tipsY = y + h - tipsHeight;
			}
			if (quadrant == 2)
			{
				tipsX = x - tipsSpace - tipsWidth;
				tipsY = y + h - tipsHeight;
			}
			if (quadrant == 3)
			{
				tipsX = x - tipsSpace - tipsWidth;
				tipsY = y;
			}
			if (quadrant == 4)
			{
				tipsX = x + w + tipsSpace;
				tipsY = y;
			}
			currentTips.tipsX = tipsX;
			currentTips.tipsY = tipsY;
			drawCornerRect(tipsCtx,tipsX,tipsY,tipsWidth,tipsHeight,tipsWidth/10);
		}
		//隐藏悬浮框 
		function hideTips(){
			if (currentTips.x != -1 && currentTips.y != -1)
			{
				tipsCtx.beginPath();
				tipsCtx.fillStyle=canvasBackgroundColor;
				tipsCtx.rect(currentTips.tipsX -5,currentTips.tipsY-5,tipsWidth+ 10,tipsHeight+ 10);
				tipsCtx.closePath();
				tipsCtx.fill();
				currentTips = {x:-1,y:-1,tipsX:0,tipsY:0};
			}
		}

		//p0、p1、p2三个点，其中p0为起点，p2为终点，p1为控制点  
		//t的范围是0-1  
		//贝赛尔曲线坐标函数
		function qBerzier(p0,p1,p2,t){  
		  var x = (1 - t) * (1 - t) * p0.x + 2 * t * (1 - t) * p1.x + t * t * p2.x;  
		  var y = (1 - t) * (1 - t) * p0.y + 2 * t * (1 - t) * p1.y + t * t * p2.y;  
		  return {x:x,y:y};  
		}  
		//===========事件处理end=================
	},
}


// WEBPACK FOOTER //
// ./src/page/yuqingFenxi/components/Route_Map.js